import {
  Button,
  Divider,
  Flex,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';
import { FaPlus } from 'react-icons/fa6';
import { useCallback } from 'react';
import { Link, useHistory, useLocation, useRouteMatch } from 'react-router-dom';
import usePermissionStatusByKey from '../../../../hooks/usePermissionStatusByKey';

const DashboardLayout = ({ availableTabs, children }) => {
  const location = useLocation();
  const borderColor = useColorModeValue('blue.50', 'rgba(255, 255, 255, 0.10)');

  return (
    <>
      <Flex
        align="left"
        mb={{ sm: '10px', md: '0px' }}
        direction={{ sm: 'column', md: 'row' }}
        w={{ sm: '100%' }}
        textAlign={{ sm: 'center', md: 'start' }}
        borderBottom="1px"
        borderColor={borderColor}
        className="settings-tabs"
      >
        {availableTabs.includes('/') && (
          <Link
            to={'/dashboard'}
            className={
              location.pathname === '/dashboard' ? 'settings-tab-active' : ''
            }
          >
            State Prices
          </Link>
        )}
        {availableTabs.includes('/general') && (
          <Link
            to={'/dashboard/general'}
            className={
              location.pathname === '/dashboard/general'
                ? 'settings-tab-active'
                : ''
            }
          >
            General Stats
          </Link>
        )}
      </Flex>
      <Divider
        opacity="1"
        mr="2px"
        borderColor={borderColor}
        borderTopWidth="1px"
        borderBottomWidth="0"
        mb="32px"
      />

      {children}
    </>
  );
};

export default DashboardLayout;
